<template>
  <div v-if="comments.length > 0" class="observations" :class="containerClass">
    <div class="col-sm-12 mb-4">
      <h5 class="mb-3">{{ title }}</h5>

      <div class="table-responsive">
        <el-table class="observation-table-white" :data="comments" header-row-class-name="thead-light" row-key="id">
          <el-table-column label="Fecha" min-width="100px" prop="date">
            <template #default="{ row }">
              <span class="d-block font-weight-bold">{{ row.date | date('DD/MM/YYYY') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Observación" min-width="220px" prop="body">
            <template #default="{ row }">
              <span class="font-weight-bold">{{ row.body }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="edit" min-width="80px" label="">
            <template #default="{ row }">
              <base-button class="rounded-pill" size="sm" type="primary" @click="editComment(row)">
                <i class="fas fa-pen mr-1"></i>Editar
              </base-button>
              <base-button class="rounded-pill" size="sm" type="danger" @click="remove(row.id)">
                <i class="fas fa-trash mr-1"></i>Eliminar
              </base-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import swal from 'sweetalert2';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    comments: {
      type: Array,
      default: () => [],
    },

    containerClass: {
      type: String,
      default: 'row justify-content-center',
    },

    edit: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    editComment(comment) {
      this.$emit('edit', comment);
    },

    remove(id) {
      swal({
        title: `Va a eliminar un comentario!`,
        text: `¿Está seguro que desea continuar?`,
        buttonsStyling: false,
        confirmButtonText: `Eliminar`,
        confirmButtonClass: 'btn btn-danger',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `Cancelar`,
        cancelButtonClass: 'btn btn-success',
      }).then((result) => {
        if (result.value) {
          this.$emit('delete', id);
        }
      });
    },
  },
};
</script>
